import React, {  useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useGlobal } from 'reactn';
import { signup } from '../../api/auth';
import myAccountIcon from '../assets/myAccountIcon.png';
import sendIcon from '../assets/sendIcon.png';
import Button from '../common/button/Button';
import Card from '../common/card/Card';
//import Form, { Input, Label } from '../common/form/Form';
import { Alert } from 'antd';

const Signup = () => {
  const [auth] = useGlobal('SignupResponseData');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const form = useForm();
  const { register, handleSubmit, control, formState } = form;
  const { errors } = formState;


  const onSubmit = async ({ first_name, last_name, email, password }) => {
    setLoading(true);
    setTimeout(async () => {
      const res = await signup(first_name, last_name, email, password);     
      if (res && res.error) {
        setErrorMessage(res.error);
        // res.error is the backend validation error message
        setLoading(false);
        return;
      }
      if (res && !res.error) {
        setLoading(false);
      }
    }, 1000);
    return;
  };

  const renderSignup = () => {
    return (
      <Card
        className="w-full lg:max-w-2xl"
        backgroundClass="bg-white"
        title="MCWA Customer Portal Sign Up"
        titleClassName="text-center justify-center"
        ActionComponent_top={
          <img
            className="mx-auto mb-3"
            src={myAccountIcon}
            alt="account-icon"
          />
        }
        headerGroupClassName="flex-col mx-auto"
        >
        <form
          onSubmit={handleSubmit(onSubmit)} 
          className="flex flex-col"
         >
          
          <label className="text-black" htmlFor="first_name">
            First Name
          </label>
          <input type="text" id="first_name" placeholder="First Name"  control={control}   disabled={loading} error="errors.first_name" className="ant-input p-4 my-2 h-auto text-lg border rounded-none" 
          {...register("first_name", {required: {
            value: true, 
            message: "First Name is required"} } 
          )}       
            aria-invalid={errors.first_name ? "true" : "false"}
          />        
            { 
              <p className="text-red-500">{errors.first_name?.message} </p>
            }

          <label className="text-black" htmlFor="last_name">
            Last Name
          </label>
          <input type="text" id="last_name" placeholder="Last Name"  control={control}   disabled={loading} error="errors.first_name" className="ant-input p-4 my-2 h-auto text-lg border rounded-none"
          {...register("last_name", {required: {
            value: true, 
            message: "Last Name is required"}})}
            aria-invalid={errors.last_name ? "true" : "false"}
          />
            { 
              <p className="text-red-500">{errors.last_name?.message} </p>
            }

          <label className="text-black" htmlFor="email">
            Email
          </label>
          <input type = "email" id= "email" placeholder="Email" control={control}   disabled={loading} error="errors.email" className="ant-input p-4 my-2 h-auto text-lg border rounded-none"
          {...register("email", {required: {
            value: true, 
            message: "Email is required"}})}
            aria-invalid={errors.email ? "true" : "false"}       
          />
            { 
              <p className="text-red-500">{errors.email?.message} </p>
            }

          <label className="text-black" htmlFor="password">
            Password
          </label>
          <input type={!showPassword ? "password": "text"} id= "password"  control={control}   disabled={loading} error="errors.password" placeholder="Password" className=" ant-input p-4 my-2 h-auto text-lg border rounded-none" {...register("password", {required: {
            value: true, 
            message: "Password is required"}})}
            aria-invalid={errors.email ? "true" : "false"}       
          />
            { 
              <p className="text-red-500">{errors.password?.message} </p>
            }

            <p
              className="text-xs w-full text-right  cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {!showPassword ? 'Show Password' : 'Hide Password'}
            </p>
  
            <ul>
              <li>Password cannot be less than 8 characters</li>
              <li>Password must contain at least 2 lowercase letters</li>
              <li>Password must contain at least 2 uppercase letters</li>
              <li>Password must contain at least 2 numbers</li>
              <li>
                Password must contain at least 2 special characters (i.e. &*$%)
              </li>
              <li>Password cannot contain your name</li>
            </ul>
       
          <Button loading={loading} type ="submit" htmlType="submit">
            Sign up
          </Button>
              {errorMessage && (
                  <Alert  description={errorMessage} type="error" role="alert"> 
                  </Alert>                            
              )}
        </form>
        
        <div className="mt-4 text-center">
          <p className="font-bold text-black">Already a User?</p>
          <Link className="text-black" to="/auth/signin">
            Sign In &rsaquo;
          </Link>
        </div>
      </Card>
    );
  };

  const renderConfirmationEmail = () => {
    return (
      <Card
        className="w-full lg:max-w-2xl"
        backgroundClass="bg-white text-center"
        title="MCWA Customer Portal Signup Confirmation"
        padded
      >
        <img className="mx-auto mb-5" src={sendIcon} alt="send-icon" />
        <h1>Sent!</h1>
        <p className="text-xl">We have sent you an email for confirmation.</p>
        <Link to="/auth/signin">Return to Signin &rsaquo;</Link>
      </Card>
    );
  };
  return auth && auth.msg ? renderConfirmationEmail() : renderSignup();
};

export default Signup;
